import React from 'react';
import { Link as ReactLink } from 'react-router-dom';
import styled from 'styled-components';

interface ILink {
  text?: string;
  href?: string;
  target?: string;
  icon: React.ReactNode;
  onClick?: (value: any) => void;
}

const StyledLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  cursor: pointer;
  text-decoration: none;
  font-size: 16px;
  color: #f82e52;
  font-weight: 700 !important;
  &:hover {
    color: #f82e52;
    text-decoration: none;
  }
`;

const IconWrapper = styled.div`
  font-size: 16px;
`;

const Link = ({ text, href, target, icon, onClick, ...props }: ILink) => {
  if (target === 'internal') {
    return (
      <ReactLink to={href || ''} data-testid="link" {...props}>
        <IconWrapper>{icon}</IconWrapper>
        {text}
      </ReactLink>
    );
  }

  return (
    <StyledLink onClick={onClick} {...props}>
      <IconWrapper>{icon}</IconWrapper>
      {text}
    </StyledLink>
  );
};

export default Link;
